<mat-dropdown
  [formControl]="formControl()"
  [options]="dropdownOptions"
  [configurationInput]="dropdownSettings"
  [isFormSubmitted]="isFormSubmitted()"
></mat-dropdown>
